/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import _ from "lodash";
import React from "react";
import AdminPopupComponent from "../../../../../shared-ui/popup/admin-popup";
// import "react-accessible-accordion/dist/fancy-example.css";

interface SingleChoiceComponentProps {
  questionType: string;
  questionValue: string;
  questionTitle: string;
  optionList: any;
  optionsListWithAnswer?: any;
  dependent?: any;
  isPath?: any;
  disableAllAnswers?: boolean;
  handleInputChange?: (
    questionType: string,
    questionValue: string,
    questionTitle: string,
    answer: any,
    isNeedState: boolean,
    isValueFound: boolean,
    dependentQuestions: any
  ) => void;
}

interface SingleChoiceComponentState {
  listOfOptions: any;
  questionTitleState: string;
  optionsListWithAnswer: any;
  isPopUpOpen: boolean;
  isSelected: boolean;
  iscancle: boolean;
  id: any;
  value: any;
  selectedAnswer: any;
}

class SingleChoiceComponent extends React.Component<
  SingleChoiceComponentProps,
  SingleChoiceComponentState
> {
  node: any;
  constructor(props: any) {
    super(props);
    this.state = {
      listOfOptions: [],
      questionTitleState: "",
      optionsListWithAnswer: [],
      isPopUpOpen: false,
      isSelected: false,
      iscancle: false,
      id: "",
      value: "",
      selectedAnswer: {},
    };
  }

  componentDidMount = () => {
    let data = [...this.props.optionList];
    data.forEach(function (item: { isChecked: boolean }) {
      // if()
      item.isChecked = false;
    });
    if (
      this.props.optionsListWithAnswer !== undefined &&
      this.props.questionValue !== "Path"
    ) {
      let selected = _.find(
        data,
        (obj) => obj.id === this.props.optionsListWithAnswer?.id
      );
      let index = _.findIndex(data, this.props.optionsListWithAnswer);
      selected.isChecked = true;
      data.splice(index, 1, selected);
      this.setState({
        listOfOptions: data,
      });
    } else {
      data.forEach(function (item: { isChecked: boolean }) {
        item.isChecked = false;
      });
      this.setState({
        listOfOptions: data,
      });
    }
  };

  componentDidUpdate = () => {
    if (this.state.isPopUpOpen) {
      // attach/remove event handler
      document.addEventListener("click", this.handleOutsideClick, true);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    if (this.props.questionValue !== "Path") {
      if (
        this.state.questionTitleState !== this.props.questionTitle ||
        (this.props.optionsListWithAnswer !== undefined &&
          this.state.selectedAnswer !== this.props.optionsListWithAnswer)
      ) {
        this.setState({
          questionTitleState: this.props.questionTitle,
          selectedAnswer: this.props.optionsListWithAnswer,
        });

        let data = [...this.props.optionList];
        data.forEach(function (item: { isChecked: boolean }) {
          // if()
          item.isChecked = false;
        });
        if (
          this.props.optionsListWithAnswer !== undefined &&
          this.props.questionValue !== "Path"
        ) {
          let selected = _.find(
            data,
            (obj) => obj.id === this.props.optionsListWithAnswer?.id
          );
          let index = _.findIndex(data, this.props.optionsListWithAnswer);
          selected.isChecked = true;
          data.splice(index, 1, selected);
          this.setState({
            listOfOptions: data,
          });
        } else {
          data.forEach(function (item: { isChecked: boolean }) {
            item.isChecked = false;
          });
          this.setState({
            listOfOptions: data,
          });
        }
      }
    } else {
      if (
        this.state.optionsListWithAnswer !== this.props.optionsListWithAnswer
      ) {
        this.props.questionValue === "Path" &&
          this.setState({
            optionsListWithAnswer: this.props.optionsListWithAnswer,
          });

        let data = [...this.props.optionList];
        data.forEach(function (item: { isChecked: boolean }) {
          // if()
          item.isChecked = false;
        });
        if (this.props.optionsListWithAnswer !== undefined) {
          let selected = _.find(
            data,
            (obj) => obj.id === this.props.optionsListWithAnswer?.id
          );
          let index = _.findIndex(data, this.props.optionsListWithAnswer);
          selected.isChecked = true;
          // data.splice(index, 1, selected);
          this.setState({
            listOfOptions: data,
          });
        } else {
          data.forEach(function (item: { isChecked: boolean }) {
            item.isChecked = false;
          });
          this.setState({
            listOfOptions: data,
          });
        }
      }
    }
  };

  handleOutsideClick = (e: any) => {
    // ignore clicks on the component itself
    if (this.node) {
      if (this.node.contains(e.target)) {
        return;
      }
      this.handleClose();
    }
  };

  handleRadioButtonChange = (id: string, value: string, index: number) => {
    const { questionValue, questionTitle, questionType, dependent, isPath } =
      this.props;
    const { listOfOptions, isSelected } = this.state;

    if (
      (questionValue === "Path" && isSelected) ||
      (questionValue === "Path" && isPath)
    ) {
      this.setState({
        isPopUpOpen: true,
        isSelected: true,
      });
      this.setState({
        id: id,
        value: value,
      });
    } else {
      let data: any = listOfOptions;
      data.forEach((item: any) => {
        if (item.value === value) {
          item.isChecked = true;
        } else {
          item.isChecked = false;
        }
      });
      this.setState({
        listOfOptions: data,
        isSelected: true,
      });
      if (this.props.handleInputChange) {
        let isValueFound = false;
        let dependentQuestions: any = [];
        if (dependent && dependent.length > 0) {
          const conditionsArray = dependent[0]?.conditions;
          isValueFound = _.includes(conditionsArray, id);
          dependentQuestions = dependent[0]?.questions;
        }
        this.props.handleInputChange(
          questionType,
          questionValue,
          questionTitle,
          {
            id,
            value,
          },
          false,
          isValueFound,
          dependentQuestions
        );
      }
    }
  };

  /**
   * This method is used to persist data click on cancle button on pop up
   *
   */
  handleClose = () => {
    this.setState({
      isPopUpOpen: false,
      isSelected: true,
    });
  };

  /**
   * This method is used to Discard data on back button
   *
   */
  handleDiscard = () => {
    const { questionValue, questionTitle, questionType, dependent } =
      this.props;
    const { listOfOptions, isSelected, id, value } = this.state;
    let data: any = listOfOptions;
    data.forEach((item: any) => {
      if (item.value === value) {
        item.isChecked = true;
      } else {
        item.isChecked = false;
      }
    });
    this.setState({
      listOfOptions: data,
      isSelected: true,
    });
    if (this.props.handleInputChange) {
      let isValueFound = false;
      let dependentQuestions: any = [];
      if (dependent && dependent.length > 0) {
        const conditionsArray = dependent[0]?.conditions;
        isValueFound = _.includes(conditionsArray, id);
        dependentQuestions = dependent[0]?.questions;
      }
      this.props.handleInputChange(
        questionType,
        questionValue,
        questionTitle,
        {
          id,
          value,
        },
        false,
        isValueFound,
        dependentQuestions
      );
    }
    this.setState(
      {
        isPopUpOpen: false,
      },
      () => {
        localStorage.removeItem("answersObj");
      }
    );
  };
  render() {
    const { optionList, questionValue, disableAllAnswers, isPath } = this.props;
    const { listOfOptions, isPopUpOpen } = this.state;
    return (
      <div
        className={
          disableAllAnswers ? "answers-wrapper disabled" : "answers-wrapper"
        }
      >
        {/* Back Popup Start */}
        {isPopUpOpen && (
          <AdminPopupComponent
            open={isPopUpOpen}
            close={this.handleClose}
            onDelete={this.handleDiscard}
            buttonName={"Discard"}
            cancleButtonName={"Cancel"}
            heading={"Hold on"}
            title={
              "Are you sure you want to change your path? You’ll lose any unsaved changes."
            }
          />
        )}
        {/* Back Admin Popup End */}
        <div className="options-area">
          {listOfOptions &&
            listOfOptions.length > 0 &&
            listOfOptions.map((option: any, index: number) => (
              <div
                className={
                  option && option.isChecked ? "option active" : "option"
                }
                onClick={() =>
                  this.handleRadioButtonChange(option.id, option.value, index)
                }
              >
                <div className="radio-btn">
                  <input
                    type="radio"
                    id={option.id}
                    checked={option && option.isChecked}
                    value={option.value || ""}
                    name={questionValue}
                    onChange={() =>
                      this.handleRadioButtonChange(
                        option.id,
                        option.value,
                        index
                      )
                    }
                  />
                  <span className="checkmark" />
                </div>
                <div className="option-label">{option?.value}</div>
              </div>
            ))}
        </div>
      </div>
    );
  }
}

export default SingleChoiceComponent;
